// extracted by mini-css-extract-plugin
export var container = "_tw-0";
export var table = "_tw-2";
export var tableWrapper = "_tw-1";